import React from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import { Col, Row } from 'react-bootstrap'
import classNames from 'classnames'

/**
 * A Banner with a pre defined background color, title, description and children.
 * Title is full width, description md4 and children md7.
 * If no description was given children are full width.
 *
 * @param {'green' | 'blue' | 'pink' | 'yellow' } backgroundColor
 */
const ColoredBanner = ({ backgroundColor = 'green', title, desc, children, image = null, subHeadline = null }) => {
  const containerClassnames = classNames({
    'colored-banner__imaged': image ? true : '',
    'colored-banner__container': true,
    'colored-banner__container--green': backgroundColor === 'green',
    'colored-banner__container--blue': backgroundColor === 'blue',
    'colored-banner__container--pink': backgroundColor === 'pink',
    'colored-banner__container--yellow': backgroundColor === 'yellow',
  })

  const isImageUrl = typeof image === 'string';

  return (
    <>
      {image && (isImageUrl ? 
          <img alt={title} className="colored-banner__thumbnail" src={image} /> : 
          <GatsbyImage alt={title} className="colored-banner__thumbnail" image={getImage(image)} />
      )}
      <Row className={containerClassnames}>
        <Col xs={12}>
          {subHeadline && <div className="colored-banner__subheadline">{subHeadline}</div>}
          <h1 className="colored-banner__title">{title}</h1>
        </Col>

        {(desc || children) && (
          <Col xs={12}>
            <Row>
              {desc && <Col xs={12} md={4} className="colored-banner__desc">{desc}</Col>}

              {children && (
                <Col xs={12} md={desc ? { span: 7, offset: 1 } : 12} className="colored-banner__children">
                  {children}
                </Col>
              )}
            </Row>
          </Col>
          )}
      </Row>
    </>
  )
}

export default ColoredBanner
